import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=f4a37b10&scoped=true&"
import script from "./RouteDetail.vue?vue&type=script&lang=js&"
export * from "./RouteDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=f4a37b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a37b10",
  null
  
)

component.options.__file = "RouteDetail.vue"
export default component.exports